import { graphql } from '../../gql';

export const PAYOUT_TRANSACTION_FRAGMENT = graphql(`
  fragment PayoutTransactionFragment on PayoutTransaction {
    ... on PayoutTransactionStripe {
      transactionId
      to {
        bankName
        accountName
        last4Digits
        amount
        currencyCode
      }
    }
    ... on PayoutTransactionManual {
      reference
      to {
        note
        type
        amount
        currencyCode
      }
    }
  }
`);

export const GET_ORDER_QUERY = graphql(`
  query GetSellerOrderQuery($id: ID!) {
    sellerOrder(id: $id) {
      id
      idAlias
      orderDate
      orderFee
      total
      totalFees
      totalProductFees
      totalPayout
      refundedTotal
      refundedPayoutTotal
      refundedAfterPayout
      acceptedAt
      fulfilledAt
      payout {
        id
        idAlias
        payoutDate
        payoutDueDate
        transaction {
          ...PayoutTransactionFragment
        }
      }
      customer {
        firstName
        lastName
        email
        phone
        shippingAddress {
          address1
          address2
          city
          country
          countryCode
          company
          name
          province
          provinceCode
          zip
        }
      }

      shippingCommission {
        percentage
        amount
      }
      appliedDeductions {
        name
        type
        rate
        amount
      }
      items {
        productId
        productIdAlias
        sku
        title
        productThumbnail
        featuredImage {
          thumbnailUrl
          altText
        }
        total
        totalFees
        unitPrice
        shippingPrice
        productVariantOptions {
          name
          value
        }
        quantity
        refundedQuantity
        productCommission {
          percentage
          amount
          basis
          base
          unitCost
        }
        productFee
      }
      status
      fulfillment {
        trackingNumber
        shippingCarrier
        trackingUrl
      }
    }
  }
`);

/**
 * Edits the tracking on an already-fulfilled order. Distinct from
 * fulfillSellerOrder, which transitions the order — a mistyped tracking number
 * previously had no way back short of contacting the shop.
 */
export const UPDATE_FULFILLMENT_MUTATION = graphql(`
  mutation UpdateFulfillmentMutation($id: ID!, $trackingInfo: TrackingDetailsInput!) {
    updateFulfillment(id: $id, trackingInfo: $trackingInfo) {
      id
      status
      fulfillment {
        trackingNumber
        shippingCarrier
        trackingUrl
      }
    }
  }
`);

export const ACCEPT_ORDER_MUTATION = graphql(`
  mutation AcceptSellerOrderMutation($id: ID!, $accepted: Boolean!) {
    acceptSellerOrder(id: $id, accepted: $accepted) {
      id
      idAlias
      orderDate
      orderFee
      total
      totalFees
      totalProductFees
      totalPayout
      refundedTotal
      refundedPayoutTotal
      refundedAfterPayout
      payout {
        id
        idAlias
        payoutDate
        transaction {
          ...PayoutTransactionFragment
        }
      }
      customer {
        firstName
        lastName
        email
        phone
        shippingAddress {
          address1
          address2
          city
          country
          countryCode
          company
          name
          province
          provinceCode
          zip
        }
      }
      shippingCommission {
        percentage
        amount
      }
      appliedDeductions {
        name
        type
        rate
        amount
      }
      items {
        productId
        title
        total
        unitPrice
        shippingPrice
        quantity
        refundedQuantity
        productCommission {
          percentage
          amount
          basis
          base
          unitCost
        }
        productFee
      }
      status
    }
  }
`);

export const CANCEL_ORDER_MUTATION = graphql(`
  mutation CancelSellerOrderMutation(
    $id: ID!
    $details: CancelSellerOrderDetailsInput!
  ) {
    cancelSellerOrder(id: $id, details: $details) {
      id
      idAlias
      orderDate
      orderFee
      total
      totalFees
      totalProductFees
      totalPayout
      refundedTotal
      refundedPayoutTotal
      refundedAfterPayout
      payout {
        id
        idAlias
        payoutDate
        transaction {
          ...PayoutTransactionFragment
        }
      }
      customer {
        firstName
        lastName
        email
        phone
        shippingAddress {
          address1
          address2
          city
          country
          countryCode
          company
          name
          province
          provinceCode
          zip
        }
      }
      shippingCommission {
        percentage
        amount
      }
      appliedDeductions {
        name
        type
        rate
        amount
      }
      items {
        productId
        title
        total
        unitPrice
        shippingPrice
        quantity
        refundedQuantity
        productCommission {
          percentage
          amount
          basis
          base
          unitCost
        }
        productFee
      }
      status
    }
  }
`);
